export default {
    common: {
        home: 'Početna',
        o_nama: 'O nama',
        usluge: 'Usluge',
        projekti: 'Projekti',
        nas_tim: 'Naš tim',
        karijera: 'Karijera',
        contact: 'Kontakt',
        language: 'Jezik',
        yes: 'Da',
        no: 'Ne',
        contact_message: 'Možete nas kontaktirati ili posjetiti u radno vrijeme.',
        read_more: 'Pročitaj više',
    },

    footer: {
        description: 'Profesionalna elektro firma sa dugogodišnjim iskustvom u pružanju kvalitetnih električarskih usluga za domaćinstva, poslovne i industrijske objekte.',
        contact_info: 'Kontakt informacije',
        location: 'Slovenija / Evropa',
        rights: 'Sva prava zadržana.',
        email_subject: 'Upit preko web sajta',
        email_body: 'Pozdrav,\n\nMolim vas za više informacija.',
    },

    slogans: {
        prvi_slajd: 'MAMONT - Snaga pouzdanosti, stručnost bez granica!',
        drugi_slajd: 'Inovativna rješenja za svaki strujni izazov.',
        treci_slajd: 'MAMONT – Gradimo budućnost, kabel po kabel.',
    },

    homepage: {
        hero_eyebrow: 'Elektro-montaža • Industrija • Energetika',
        hero_text: 'Pouzdana elektro-montažna rješenja za industrijske, poslovne i tehnički zahtjevne projekte širom Evrope.',
        pogledaj_usluge: 'Pogledaj usluge',
        prijavi_se: 'Prijavi se za posao',

        zadovoljnih_klijenata: 'Zadovoljnih klijenata',
        projekata: 'Projekata',
        zaposlenih: 'Zaposlenih',

        why_eyebrow: 'Zašto izabrati nas',
        zasto_mamont: 'Zašto MAMONT?',
        why_description: 'Kombinujemo iskustvo, stručan kadar i odgovoran pristup kako bismo svaki projekat izveli kvalitetno, sigurno i u dogovorenim rokovima.',

        reason_1_title: 'Pouzdanost',
        zato_sto: 'Zato što svakom projektu pristupamo odgovorno i precizno.',
        reason_2_title: 'Lojalnost',
        lojalnost: 'Gradimo dugoročne odnose sa klijentima i partnerima.',
        reason_3_title: 'Iskustvo',
        iskustvo: 'Naš tim ima iskustvo na zahtjevnim elektro-montažnim projektima.',
        reason_4_title: 'Stručan kadar',
        visokokvalifikovani_radnici: 'Raspolažemo visokokvalifikovanim radnicima spremnim za ozbiljne projekte.',

        project_eyebrow: 'Rad na terenu',
        svaki_projekat: 'Svaki projekat zahtijeva odgovornost, preciznost i tim kojem možete vjerovati.',
        pogledaj_projekte: 'Pogledaj projekte',

        team_eyebrow: 'Naš tim',
        mamont_tim_u_akciji: 'Mamont tim u akciji',
        za_nas: 'Za nas je svaki projekat odgovornost prema klijentu, timu i standardu koji gradimo.',
        upoznaj_tim: 'Upoznaj tim',

        klijenti_od_povjerenja: 'Klijenti od povjerenja',
        partneri: 'Naši partneri',
        sa_zadovoljstvom: 'Sa zadovoljstvom ističemo partnere i klijente koji su nam ukazali povjerenje.',
    },

    about_us: {
        hero_title: 'Pouzdan partner za projekte širom Evrope',

        mi_smo_kompanija_mamont: 'Mi smo kompanija MAMONT d.o.o., sinonim za kvalitet, pouzdanost i inovativnost u oblasti elektroinstalacija.',
        ko_smo_mi: 'Ko smo mi',
        firma_sa_iskustvom: 'Firma sa dugogodišnjim iskustvom i posvećenošću kvalitetu, sa sjedištem u Sloveniji. Naše usluge pružamo klijentima širom Evrope, uključujući Njemačku, Belgiju, Nizozemsku i Italiju. Naša dugogodišnja tradicija i iskustvo u realizaciji zahtjevnih projekata čine nas pouzdanim partnerom u svim aspektima elektroinstalacija.',

        feature_1_title: 'Elektro-montaža',
        feature_1_text: 'Izvođenje elektroinstalacija i montaža sistema za industrijske i poslovne objekte.',
        feature_2_title: 'Pouzdan partner',
        feature_2_text: 'Dugoročna saradnja sa klijentima zasnovana na povjerenju i kvalitetu.',
        feature_3_title: 'Stručan tim',
        feature_3_text: 'Iskusni radnici spremni za rad na zahtjevnim projektima u Evropi.',

        projects_across_europe: 'Projekti širom Evrope',

        misija: 'Misija',
        nasa_misija: 'Naša misija je jednostavna — pružiti sveobuhvatna, efikasna i inovativna rješenja koja zadovoljavaju i premašuju očekivanja naših klijenata.',
        strpljiv_pristup: 'Kroz strpljiv pristup, posvećenost kvalitetu i tim visokokvalifikovanih stručnjaka, gradimo dugoročne odnose sa saradnicima.',

        values_eyebrow: 'Naše vrijednosti',
        values_title: 'Vrijednosti koje nas vode',
        values_description: 'U svakom projektu držimo se istih principa: odgovornost, sigurnost, preciznost i poštovanje dogovorenih rokova.',

        value_1_title: 'Sigurnost',
        value_1_text: 'Sigurnost radnika, klijenata i objekata uvijek je prioritet.',
        value_2_title: 'Inovativnost',
        value_2_text: 'Primjenjujemo moderna rješenja i efikasne metode rada.',
        value_3_title: 'Kvalitet',
        value_3_text: 'Svaki detalj mora biti izveden profesionalno i precizno.',
        value_4_title: 'Odgovornost',
        value_4_text: 'Poštujemo dogovorene rokove, standarde i potrebe klijenata.',
    },

    services: {
        nase_usluge: 'Naše usluge',
        hero_title: 'Elektro-montažna rješenja za ozbiljne projekte',
        navescemo_usluge: 'U nastavku izdvajamo ključne usluge koje Mamont pruža kroz stručan tim, iskustvo i rad na zahtjevnim projektima širom Evrope.',
        posalji_upit: 'Pošalji upit',

        what_we_do: 'Šta radimo',
        services_description: 'Od pružanja kablova i instalacije kanalica, do testiranja sistema — fokusirani smo na kvalitet, sigurnost i preciznost izvođenja.',

        service_tag_1: 'Elektro-montaža',
        pruzanje_kablova: 'Pružanje kablova',
        pruzanje_kablova_nacin: 'Profesionalno pružanje kablova uz planiranje trasa, preciznu organizaciju rada i poštovanje tehničkih standarda.',

        service_tag_2: 'Kontrola kvaliteta',
        testiranje_sistema: 'Testiranje sistema',
        oprema_za_testiranje: 'Korištenje odgovarajuće opreme za provjeru, testiranje i kontrolu ispravnosti izvedenih elektro sistema.',

        service_tag_3: 'Instalacije',
        instalacija_kanalica: 'Instalacija kanalica',
        instalacija_kanalica_text: 'Montaža elektro kanalica i kablovskih trasa za industrijske, poslovne i tehnički zahtjevne objekte.',

        zatrazi_ponudu: 'Zatraži ponudu',

        process_eyebrow: 'Način rada',
        process_title: 'Od dogovora do izvedbe — jasno, precizno i odgovorno.',
        process_text: 'Svaki projekat posmatramo kroz planiranje, organizaciju tima, sigurnost na terenu i kvalitet završne izvedbe.',

        step_1_title: 'Analiza projekta',
        step_1_text: 'Razumijemo potrebe klijenta, obim posla i tehničke zahtjeve projekta.',
        step_2_title: 'Organizacija tima',
        step_2_text: 'Planiramo ljude, opremu, dinamiku rada i sigurnosne procedure.',
        step_3_title: 'Izvedba na terenu',
        step_3_text: 'Radimo precizno, odgovorno i u skladu sa dogovorenim rokovima.',

        cta_eyebrow: 'Trebate pouzdan tim?',
        cta_title: 'Razgovarajmo o vašem projektu.',
        cta_text: 'Pošaljite nam upit i javit ćemo vam se sa informacijama za saradnju.',
        kontaktirajte_nas: 'Kontaktirajte nas',

        email_subject: 'Upit za Mamont usluge',
        email_body: 'Pozdrav,\n\nMolim vas za više informacija o vašim uslugama.',
    },

    projects: {
        nasi_projekti: 'Naši projekti',
        hero_title: 'Projekti izvedeni sa preciznošću, odgovornošću i iskustvom',
        nasa_firma: 'Naša firma učestvuje u realizaciji elektro-montažnih projekata za industrijske i poslovne objekte širom Evrope.',

        gallery_eyebrow: 'Galerija radova',
        featured_projects: 'Izdvojeni projekti',
        gallery_description: 'Pogledajte dio atmosfere sa terena, radova i projekata na kojima je učestvovao Mamont tim.',
        gallery_items: 'Fotografija',
        region: 'Regija',

        project_1_title: 'Industrijske elektro instalacije',
        project_1_text: 'Radovi na elektro-montaži i instalacijama za industrijske i poslovne objekte.',

        project_2_title: 'Montaža kablovskih trasa',
        project_2_text: 'Organizovana izvedba kablovskih trasa, kanalica i pripadajuće elektro infrastrukture.',

        project_3_title: 'Radovi na terenu',
        project_3_text: 'Mamont tim na zahtjevnim projektima uz fokus na sigurnost, kvalitet i rokove.',

        project_4_title: 'Elektro-montažni projekti',
        project_4_text: 'Izvođenje radova za klijente kroz preciznu organizaciju i stručan tim.',

        project_5_title: 'Tehnička izvedba',
        project_5_text: 'Radovi na sistemima i instalacijama koji zahtijevaju iskustvo i odgovornost.',

        project_6_title: 'Projekti širom Evrope',
        project_6_text: 'Iskustvo u realizaciji projekata u Sloveniji i na evropskom tržištu.',

        project_7_title: 'Instalacije i montaža',
        project_7_text: 'Pouzdana izvedba elektro radova za različite tipove objekata.',

        project_8_title: 'Mamont tim',
        project_8_text: 'Stručan kadar, timski rad i organizacija na terenu.',

        project_9_title: 'Kvalitetna izvedba',
        project_9_text: 'Svaki projekat izvodimo sa pažnjom prema detaljima i tehničkim standardima.',

        project_10_title: 'Elektro sistemi',
        project_10_text: 'Radovi na elektro sistemima i pripadajućim instalacijama.',

        project_11_title: 'Profesionalna montaža',
        project_11_text: 'Pouzdana montaža i izvođenje radova u skladu sa zahtjevima projekta.',

        project_12_title: 'Terenski radovi',
        project_12_text: 'Praktična izvedba projekata uz iskustvo i odgovornu organizaciju.',

        project_13_title: 'Instalacija kanalica',
        project_13_text: 'Montaža kanalica i kablovskih sistema za industrijske objekte.',

        project_14_title: 'Industrijska postrojenja',
        project_14_text: 'Radovi u industrijskim okruženjima sa posebnim tehničkim zahtjevima.',

        project_15_title: 'Elektro oprema',
        project_15_text: 'Rad sa elektro opremom i instalacijama na projektima različitog obima.',

        project_16_title: 'Realizacija projekta',
        project_16_text: 'Od planiranja do završne izvedbe, fokus ostaje na kvalitetu i sigurnosti.',

        project_17_title: 'Kompleksni radovi',
        project_17_text: 'Izvođenje zahtjevnih elektro-montažnih radova sa stručnim timom.',

        project_18_title: 'Mamont projekti',
        project_18_text: 'Dio naših izvedenih radova i terenskog iskustva.',
    },

    tim: {
        stranica_u_pripremi: 'Stranica je u pripremi',
        molimo_vas: 'Molimo vas da provjerite kasnije. Vaš MAMONT',
    },

    career: {
        hero_eyebrow: 'Karijera',
        hero_title: 'Postani dio Mamont tima',
        hero_subtitle: 'Radi na velikim projektima širom Evrope',
        hero_button: 'Pošalji prijavu',

        intro_eyebrow: 'Otvorene prijave',
        intro_title: 'Tražimo odgovorne elektro-montažere i radnike spremne za teren.',
        intro_text: 'Ako imate iskustva u elektro-montaži, instalacijama, kablovskim trasama ili ste spremni učiti i raditi u ozbiljnom timu, pošaljite nam prijavu.',

        benefits: {
            projects: {
                title: 'Veliki projekti',
                text: 'Rad na ozbiljnim elektro-montažnim projektima širom Evrope.',
            },
            team: {
                title: 'Stabilan tim',
                text: 'Organizovan rad, jasna komunikacija i podrška na terenu.',
            },
            growth: {
                title: 'Profesionalni razvoj',
                text: 'Mogućnost napredovanja, učenja i dugoročne saradnje.',
            },
        },

        form_eyebrow: 'Prijava za posao',
        form_title: 'Pošalji svoje podatke',
        form_description_no_upload: 'Popunite formu i po želji dodajte link do CV-a ili dokumenta. Naš tim će pregledati prijavu i kontaktirati vas ukoliko postoji odgovarajuća pozicija.',

        note_title: 'Napomena',
        note_text: 'Polja označena zvjezdicom su obavezna.',

        email: {
            subject: 'Nova prijava za posao - Mamont',
        },

        fields: {
            full_name: 'Ime i prezime',
            email: 'E-mail adresa',
            phone: 'Telefon',
            location: 'Mjesto prebivališta',
            position: 'Pozicija za koju se prijavljujete',
            experience: 'Godine iskustva',
            availability: 'Dostupnost za početak rada',
            eu_citizen: 'Državljanin ste EU-a',
            eu_citizen_confirm: 'Da, državljanin sam EU-a',
            message: 'Radno iskustvo / kratka poruka',
            cv_upload: 'CV / dokument',
            privacy_consent: 'Saglasan/saglasna sam da Mamont obradi moje podatke u svrhu prijave za posao.',
        },

        placeholders: {
            full_name: 'Unesite ime i prezime',
            email: "ime{'@'}email.com",
            phone: '+387 / +386 / +49',
            location: 'Grad / država',
            position: 'Odaberite poziciju',
            experience: 'Odaberite iskustvo',
            availability: 'Odmah / za 15 dana / po dogovoru',
            message: 'Napišite ukratko svoje iskustvo, vještine i dostupnost za rad.',
        },

        positions: {
            electro_installer: 'Elektro-montažer',
            assistant_worker: 'Pomoćni radnik',
            team_lead: 'Vođa tima / poslovođa',
            other: 'Drugo',
        },

        experience: {
            no_experience: 'Bez iskustva',
            one_two: '1–2 godine',
            three_five: '3–5 godina',
            five_plus: '5+ godina',
        },

        file: {
            empty: 'Dodajte PDF, DOC ili DOCX dokument',
            limit: 'Maksimalna veličina dokumenta je 10 MB.',
        },

        submit: {
            default: 'Pošalji prijavu',
            loading: 'Slanje...',
        },

        success: 'Prijava je uspješno poslata. Hvala vam na interesovanju.',

        errors: {
            file_type: 'Dozvoljeni su samo PDF, DOC i DOCX dokumenti.',
            file_size: 'Dokument ne smije biti veći od 10 MB.',
            privacy_required: 'Morate potvrditi saglasnost za obradu podataka.',
            generic: 'Došlo je do greške. Pokušajte ponovo.',
        },
    },
};